

const DonationForm = () => {
    jQuery(document).on('gform_post_render', () => {
        console.log('removing load state')
    })

    $('#gform_submit_button_2').click((e) => {
        let btn = $(e.target);

        btn.val('Loading...');
        btn.addClass('btn--loading');
    })
}

export default DonationForm;


// WEBPACK FOOTER //
// ./src/js/app/components/DonationForm.js